((STU, $) => {

  let $window;
  let $sideImage;
  let $sectionContainer;
  let $nav;
  let navHeight;
  let $header;

  const cacheDom = () => {
    $window = $(window);
    $sideImage = $('.stu-side-image');
    $nav = $('.main-navigation');
    $header = $('.stu-hero');
    $sectionContainer = $('.stu-scroll-container');
  };

  const setNavHeight = () => {
    navHeight = $nav.height();
  };

  const bindUIActions = () => {
    $window.on('scroll', function sideScroll() {
      const scroll = $(this).scrollTop();
      const sectionTop = $sectionContainer.offset().top;
      const sectionBottom = sectionTop + $sectionContainer.height();

      if (scroll >= (sectionTop - navHeight)
        && scroll <= (sectionBottom + navHeight) - $window.height()) {
        $sideImage.css({
          position: 'fixed',
          top: '50%',
          bottom: 'inherit',
          transform: 'translateY(-50%)'
        });
      } else if (scroll > (sectionBottom + navHeight) - $window.height()) {
        $sideImage.css({
          position: 'absolute',
          transform: 'none',
          top: 'inherit',
          bottom: '150px'
        });
      } else {
        $sideImage.css({
          position: 'absolute',
          top: '150px',
          bottom: 'inherit',
          transform: 'none'
        });
      }
    });

    $window.on('scroll', function parallax() {
      const $image = $header.find('.stu-hero-image');
      const scroll = $(this).scrollTop();
      if ($header.height() > $(this).scrollTop()) {
        $image.css({
          transform: 'translate(-50%, -' + (scroll / 10 + 30) + '%)',
        });
      }
    });
  };

  const init = () => {
    cacheDom();

    if ($window.width() > 991) {
      setNavHeight();
      bindUIActions();
    }
  };

  STU.init = init;
})(window.STU = window.STU || { }, jQuery);
